<template>
  <div>
    <AppHeader v-if="!isSpaceViewPage" />
    <router-view />
    <AppFooter v-if="!isSpaceViewPage" />
    <el-backtop v-if="!isSpaceViewPage" :right="100" :bottom="100" />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
  },
  setup() {
    const route = useRoute();
    const isSpaceViewPage = computed(
      () => route.path.startsWith("/space/view") || route.name === "viewSpace"
    );
    return { isSpaceViewPage };
  },
};
</script>

<style scoped></style>
